import React, { Component } from 'react';
// import FontAwesome from 'react-fontawesome';
// import Gravatar from 'react-gravatar';
// import { Link } from 'react-router';
import firebase from 'firebase';
import { history } from '../store';

import './UserSettings.css';

class UserSettings extends Component {
	constructor() {
		super();

		this.state = {
			user: firebase.auth().currentUser,
			firstName: '',
			lastName: ''
		};

		firebase.database().ref('/Users/' + this.state.user.uid).once('value', userObj => {
			this.setState({
				firstName: userObj.val().firstName || '',
				lastName: userObj.val().lastName || ''
			});
		});

		this.updateProfile = this.updateProfile.bind(this);
		this.firstNameUpdated = this.firstNameUpdated.bind(this);
		this.lastNameUpdated = this.lastNameUpdated.bind(this);
		this.emailUpdated = this.emailUpdated.bind(this);
	}

	updateProfile(event) {
		event.preventDefault();
		const firstName = this.state.firstName;
		const lastName = this.state.lastName;
		const displayName = `${firstName} ${lastName}`.trim();
		const uid = this.state.user.uid;

		if (!displayName) {
			// console.log('updating user to:', displayName);
		// } else {
			return;
		}

		firebase.auth().currentUser.updateProfile({ displayName }).then(
			() => {
				firebase
					.database()
					.ref('Users/' + uid)
					.update({
						firstName: firstName,
						lastName: lastName
					})
					.then(() => {
						// console.log('Profile updated!');
						history.push('/');
					});
			},
			error => {
				// An error happened.
				const errorCode = error.code;
				const errorMessage = error.message;
				console.log(`Error ${errorCode}:`, errorMessage);
			}
		);
	}

	firstNameUpdated(event) {
		this.setState({ firstName: event.target.value });
	}
	lastNameUpdated(event) {
		this.setState({ lastName: event.target.value });
	}
	emailUpdated(event) {
		let user = this.state.user;
		user.email = event.target.value;
		this.setState({ user });
	}

	render() {
		return (
			<section id="user-settings-view" className="card">
				<div className="card-body">
					<h2>Edit Profile</h2>
					<form id="profile-form">
						<div className="form-group">
							<label htmlFor="email" className="required">Email Address</label>
							<input
								id="email"
								className="form-control"
								type="email"
								required
								value={this.state.user.email}
								disabled
							/>
						</div>
						<div className="form-group">
							<label htmlFor="first-name" className="required">First Name</label>
							<input
								id="first-name"
								className="form-control"
								type="text"
								required
								value={this.state.firstName}
								onChange={this.firstNameUpdated}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="last-name" className="required">Last Name</label>
							<input
								id="last-name"
								className="form-control"
								type="text"
								required
								value={this.state.lastName}
								onChange={this.lastNameUpdated}
							/>
						</div>
						<div className="footer-toolbar">
							<div className="toolbar">
							{/*<Link to="/" className="btn btn-secondary">Cancel</Link>*/}
								<button className="btn btn-secondary ml-auto" onClick={(e)=>{e.preventDefault(); history.push("/");}}>Cancel</button>
								<button className="btn btn-primary" type="submit" onClick={this.updateProfile}>Save</button>
							</div>
						</div>
					</form>
				</div>
			</section>
		);
	}
}

export default UserSettings;



// WEBPACK FOOTER //
// ./src/components/UserSettings.js